import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { currentDate } from '../../../core/helper';


export const Footer = () => {

    const [dateNow, setDateNow] = useState(null);

    useEffect(() => {
        setDateNow(currentDate());
    }, []);

    return (

        <footer className="text-muted d-md-flex justify-content-between text-center text-md-left">
            <div>
                <Link to="/contact-us" className="text-muted d-block d-md-inline pl-0">Contact Us</Link>|
                <a href="https://www.trueadvance.com/" rel="noopener noreferrer" target="_blank" className="text-muted">About True Advance</a>|

                {/* <Link to="/privacy" className="text-muted welcome-link mr-5">Privacy</Link> */}
                <a href="https://www.trueadvance.com/privacy-policy" rel="noopener noreferrer" className="text-muted d-block d-md-inline" target='_blank'>Privacy Policy</a>|
                <a href="https://www.trueadvance.com/terms-of-use" rel="noopener noreferrer" className="text-muted d-block d-md-inline" target='_blank'>Terms of Use</a>
            </div>

            <p className='mb-0'>Copyright True Leadership Solutions LLC. {dateNow}. All rights reserved.</p>
        </footer>

    )
}